// eslint-disable-next-line import/no-named-default
import { default as fetch, Method, setFetchConfig } from './fetch';

export { Method, setFetchConfig, fetch };

export default fetch;
